import { convertArabicNumberToEnglish } from "@/app/ui/hotels/validation";
import { useHotelFiltersContext } from "../context/HotelFiltersContext";
import { useHotelSearchDataContext } from "../context/HotelSearchDataContext";
import { useHotelSortContext } from "../context/HotelSortContext";
import { HotelTrackingEvents, rudderAnalytics } from "../rudderstack";
import type { THotelFormValues } from "../types/types";
import { usePreviousHotelSearchData } from "./usePreviousSearchData";

export const useHotelSearchForm = () => {
  const { resetSortValue } = useHotelSortContext();
  const { updateSearchData } = useHotelSearchDataContext();
  const { resetFilters } = useHotelFiltersContext();
  const { setPreviousSearchData } = usePreviousHotelSearchData();

  const handleSubmit = (values: THotelFormValues) => {
    rudderAnalytics.track(HotelTrackingEvents.USER_SEARCHED_FOR_OFFERS, {
      destination: values.destination?.name,
      travel_date: values.dates.checkIn,
      return_date: values.dates.checkOut,
      rooms: values.rooms,
    });
    resetFilters();
    resetSortValue();
    setPreviousSearchData(values);
    updateSearchData({
      ...values,
      rooms: values.rooms.map((room) => {
        return {
          ...room,
          childrenAges: room.childrenAges.map((childrenAge) => {
            if (typeof childrenAge === "string") {
              return convertArabicNumberToEnglish(childrenAge);
            }
            return childrenAge;
          }),
        };
      }),
    });
  };

  return { handleSubmit };
};
